import { ADD_MESSAGE } from '../actionTypes';
import { chatActions } from '../reducer';

export default (values) => chatActions[ADD_MESSAGE](values);
